export default "__VITE_ASSET___NZNUedD__"